import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { portalApi } from '../../utils/portalApi';

export default function EmployeeLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    portalApi.getSession().then(() => navigate('/dashboard')).catch(() => {});
  }, [navigate]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await portalApi.login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Unable to sign in');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center bg-slate-50 px-4">
      <form onSubmit={onSubmit} className="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        <h1 className="text-2xl font-semibold text-slate-900">Employee Login</h1>
        <p className="mt-1 text-sm text-slate-600">Sign in to manage Insights content.</p>
        <label className="mt-6 block text-sm font-medium text-slate-700">Email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="mt-1 w-full rounded-lg border-slate-300" />
        <label className="mt-4 block text-sm font-medium text-slate-700">Password</label>
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="mt-1 w-full rounded-lg border-slate-300" />
        {error ? <p className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p> : null}
        <button disabled={busy} className="mt-6 w-full rounded-lg bg-cam-blue px-4 py-2 text-white hover:bg-cam-blue/90 disabled:opacity-70">{busy ? 'Signing in...' : 'Sign in'}</button>
      </form>
    </main>
  );
}
